import './SocialAccountList.scss';

import {
  ChangeEvent, FC,
} from 'react';
import {
  SocialAccount,
} from 'models/Social/SocialAccount';
import { SocialSubAccount } from 'models/Social/SocialSubAccount';
import moment from 'moment';
import { Form, Table } from 'react-bootstrap';

interface SocialAccountListProps {
  socialAccounts: SocialAccount[];
  subAccounts: SocialSubAccount[];
  projectName: string | undefined;
  onSubAccountChanged: (selectedSubAccount: SocialSubAccount) => void;
}

const SocialAccountList: FC<SocialAccountListProps> = ({
  socialAccounts,
  subAccounts,
  projectName,
  onSubAccountChanged,
}) => {
  if (socialAccounts.length === 0) {
    return (
      <div className="social-account-list">
        <h3>Your Connected Social Accounts</h3>
        <p>
          You have no social accounts connected to
          {' '}
          <strong>{projectName}</strong>
          {' '}
          yet.
        </p>
      </div>
    );
  }

  return (
    <div className="social-account-list">
      <h3>Your Connected Social Accounts</h3>
      <p>
        These are the social media accounts currently connected to
        {' '}
        <strong>{projectName}</strong>
        .
      </p>
      <Table>
        <thead>
          <tr>
            <th>Platform</th>
            <th>Authenticated As</th>
            <th>Posting As</th>
            <th>Status</th>
            <th>Expires</th>
          </tr>
        </thead>
        <tbody>
          {socialAccounts.map((account) => (
            <tr key={account.id}>
              <td>{account.connectionType}</td>
              <td>{account.socialAccountName}</td>
              <td>
                {/* no form wrapper as this is in a higher level form tag */}
                <Form.Select
                  aria-label="status"
                  onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                    e.preventDefault();
                    const selectedSubAccount = subAccounts.find(
                      (s) => s.parentSocialAccountId === account.id
                          && s.id === e.target.value,
                    );
                    onSubAccountChanged(selectedSubAccount!);
                  }}
                  value={account.postAsAccountId}
                  name="statusId"
                  tabIndex={7}
                >
                  {subAccounts
                    .filter((s) => s.parentSocialAccountId === account.id)
                    .map((s) => (
                      <option value={s.id} key={s.id}>
                        {s.accountName}
                      </option>
                    ))}
                </Form.Select>
              </td>
              <td className={account.connectionStatus.toLowerCase()}>
                {account.connectionStatus}
              </td>
              <td>
                {account.tokenExpiresIn
                  ? moment(account.tokenExpiresIn).endOf('day').fromNow()
                  : 'indefinite'}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SocialAccountList;
